module.exports = __webpack_public_path__ + "img/Mstorybg2.4ccfb99b.jpg";